import Welcome from './Welcome.vue';

const components = [
  Welcome,
];

export default components;



// WEBPACK FOOTER //
// ./src/components/welcome/index.js